import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import ToolsSection from './components/ToolsSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import HowItWorksSection from './components/HowItWorksSection';
import PricingPreviewSection from './components/PricingPreviewSection';
import GoogleReviewsSection from '../../components/GoogleReviewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';



const Homepage = () => {
  // Structured Data for Google (Schema.org)
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Make Mind Automations and Digital Marketing Agency",
    "url": "https://www.makemindautomations.tech",
    "description": "Leading AI Automation Agency specializing in n8n, Make.com workflows, and AI Chatbots to help businesses save 40-70 hours monthly.",
    "priceRange": "$$$",
    "telephone": "+91 97590 49639",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Banwari, New Laxmi Nagar, Police Choki Mohalla, near Small Power House & CKI Chowk, Rampur, Adarsh Nagar",
      "addressLocality": "Najibabad",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "246763",
      "addressCountry": "IN"
    },
    "openingHours": "Mo-Sa 09:00-20:00",
    "areaServed": "India",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "3"
    },
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What kind of businesses do you work with?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "We work with agencies, coaches, ecommerce brands, SaaS companies, and local businesses that want to automate leads, CRM, support, and operations using tools like Make.com, n8n, AI, and WhatsApp."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need any technical knowledge to work with you?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "No. We handle the entire technical setup for you. You tell us your process, and we design and build the workflows so your tools talk to each other automatically."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to launch my first automation?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Simple automations can go live in 3–5 days. More complex, multi-step workflows usually take 1–3 weeks, depending on your tools and requirements."
        }
      },
      {
        "@type": "Question",
        "name": "Can you maintain and update my workflows after launch?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes. We offer ongoing support and optimization plans so your automation stack stays healthy as your business grows."
        }
      },
      {
        "@type": "Question",
        "name": "Which tools do you use to build automations?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "We primarily use Make.com and n8n, with additional support for Zapier, WhatsApp APIs, email platforms, CRMs like HubSpot or Pipedrive, and AI models such as OpenAI."
        }
      }
    ]
  })}
</script>

        {/* Primary Meta Tags */}
        <title>AI Automation & Digital Marketing Agency in India | Make Mind Automations</title>
        <meta name="description" content="AI automation & digital marketing agency in India. n8n & Make.com workflows, AI chatbots, SEO & ads that save 40+ hours a month. Book a free audit." />
        <meta name="keywords" content="AI Automation Agency India, n8n workflows, Make.com experts, Business Process Automation, AI Chatbots, Custom API Integration, Digital Marketing Agency India, SEO Services India" />
        
        {/* Open Graph / Facebook / LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.makemindautomations.tech/" />
        <meta property="og:title" content="Make Mind Automations | Reclaim 40-70 Hours Monthly" />
        <meta property="og:description" content="Stop doing manual work. We automate your sales, support, and operations with advanced AI and custom workflows." />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.makemindautomations.tech/" />
        <meta property="twitter:title" content="Make Mind Automations | AI Automation Experts" />
        <meta property="twitter:description" content="Transform your business operations with AI. Book a free consultation today." />
        
        {/* Structured Data Script */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        <link
  rel="canonical"
  href="https://makemindautomations.tech/"
/>
      </Helmet>

      <div className="min-h-screen bg-background text-foreground font-sans selection:bg-primary/20">
        <Header />
        
        <main className="flex flex-col w-full overflow-x-hidden">
          {/* The layout order is designed for conversion:
             1. Hero (Hook)
             2. Stats (Social Proof)
             3. Services (Solution)
             4. Tools (Authority)
             5. Industries (Trust)
             6. Pricing/CTA (Action)
          */}
          <HeroSection />
          <StatsSection />
          <ServicesSection />
          <ToolsSection />
          <CaseStudiesSection />
          <HowItWorksSection />
          <PricingPreviewSection />
          <GoogleReviewsSection />
          <FAQSection />
          <CTASection />         
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Homepage;